/**
 * A shared `Intl.DateTimeFormat` for a locale and its options. Building one is
 * costly — on Hermes far more than formatting with it — and a list or a month
 * grid formats hundreds of dates a render; the same few formatters serve them all.
 */
const formatters = new Map<string, Intl.DateTimeFormat>();

export function dateTimeFormat(locale: string, options: Intl.DateTimeFormatOptions = {}): Intl.DateTimeFormat {
  const key = `${locale}|${JSON.stringify(options)}`;
  let formatter = formatters.get(key);
  if (!formatter) {
    formatter = new Intl.DateTimeFormat(locale, options);
    formatters.set(key, formatter);
  }
  return formatter;
}
